import { PropsWithChildren, useEffect } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import { growthBookClient, initGrowthBookClient } from 'core/featureFlags/growthBookClient';

/**
 * Makes remote feature flags available to the tree. The provider owns
 * re-rendering on flag changes (it registers the SDK's renderer), so flags do
 * not need to be mirrored into Redux.
 *
 * No teardown on unmount: the client is a module-level singleton whose lifetime
 * is the page's, and destroying it would break a remount (StrictMode) by
 * leaving init to run against a dead instance. `initGrowthBookClient` is
 * idempotent for the same reason.
 *
 * Targeting attributes are set separately by `useSyncGrowthBookAttributes`,
 * which lives inside the router where tenant/realm context is available.
 */
export const FeatureFlagProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    initGrowthBookClient();
  }, []);

  return <GrowthBookProvider growthbook={growthBookClient}>{children}</GrowthBookProvider>;
};
